const validateStudyForm = (values: any) => {
  let errors: any = {};
  if (!values.title) {
    errors.title = 'Title is required';
  }

  if (!values.description) {
    errors.description = 'Description is required';
  }

  if (!values.ethic) {
    errors.ethic = 'Ethics ID is required';
  }

  if (values.school_study) {
    if (!values.school_name) {
      console.log("values.school_name", values.school_name);
      errors.school_name = 'School Name is required';
    }
    if (
      values?.school_postcode?.toString().length !== 4 ||
      isNaN(Number(values.school_postcode))
    ) {
      errors.school_postcode = 'Postcode must be exactly 4 digits';
    }
    if (values.school_postcode == "" || values.school_postcode == undefined) {
      errors.school_postcode = 'Postcode is required';
    }
    if (!values.yr_level) {
      errors.yr_level = 'Year Level is required';
    }
  }

  if (values.cohort_report) {
    if (values.cohort_items.length === 0) {
      errors.cohort_items = 'At least one cohort item is required';
    }
  }

  if (values.individual_report) {
    if (values.individual_items.length === 0) {
      errors.individual_items = 'At least one individual item is required';
    }
  }

  if (!values?.demographic) {
    errors.demographic = 'Demographic is required';
  }

  if (!values.group) {
      errors.group = 'A measure group is required';
  }
  return errors;
};

export default validateStudyForm;